import { MAX_SMS_MEDIA_LABEL, MAX_TASK_SMS_MEDIA_LABEL } from './misc';

export const TASK_TYPES = {
  CALLING: 'calling',
  MESSAGE: 'message',
  WALKING: 'walking',
  SMS_SURVEY: 'sms_survey',
  VOICE_RECORDING: 'voice_recording',
};

export const TASK_TYPE_NAME_MAP = {
  [TASK_TYPES.WALKING]: 'Door Knocking',
  [TASK_TYPES.CALLING]: 'Phone Banking',
  [TASK_TYPES.MESSAGE]: 'Texting',
  [TASK_TYPES.SMS_SURVEY]: 'SMS Survey',
  [TASK_TYPES.VOICE_RECORDING]: 'Landline Voicemail Push',
};

export const AUTOMATED_TASK_TYPES = [
  TASK_TYPES.MESSAGE,
  TASK_TYPES.SMS_SURVEY,
  TASK_TYPES.VOICE_RECORDING,
];

export const SHOW_CONTACTABILITY_FILTER_TASK_TYPES = [
  TASK_TYPES.CALLING,
  // TASK_TYPES.MESSAGE,
  // TASK_TYPES.SMS_SURVEY,
  // TASK_TYPES.VOICE_RECORDING,
];

export const TEXT_TASK_TYPES = [TASK_TYPES.MESSAGE, TASK_TYPES.SMS_SURVEY];

// Task types that contact voters via mobile number, so bad (mobile) numbers should be excluded.
// Calling + texting; excludes landline voice recording and walking.
export const EXCLUDE_BAD_NUMBER_TASK_TYPES = [TASK_TYPES.CALLING, ...TEXT_TASK_TYPES];

export const RECIPIENT_SOURCES = {
  VOTERS: 'voters',
  UPLOAD: 'upload',
};

export const VOICE_TASK_TYPES = [TASK_TYPES.CALLING, TASK_TYPES.VOICE_RECORDING];

// Task types that may not be run in a state, keyed by task type code, listing two-letter state
// codes. An org whose every state blocks a type never sees it; a multi-state org sees it but
// cannot create one that reaches a blocked state. See src/utils/task-type-state-block.js.
export const TASK_TYPE_BLOCKED_STATES = {
  [TASK_TYPES.VOICE_RECORDING]: ['MN'],
};

// Task types no one can create right now; tasks that already exist keep working. Landline
// Voicemail Push is paused for Election Day 2026: pushes share Twilio's calls-per-second queue with
// the power dialer and stalled every power-dialed task on 2026-11-02. Empty this list to offer it
// again. See src/utils/task-type-pause.js.
export const PAUSED_TASK_TYPES = [TASK_TYPES.VOICE_RECORDING];

export const TASK_TYPE_ID_MAP = {
  [TASK_TYPES.WALKING]: 1,
  [TASK_TYPES.CALLING]: 2,
  [TASK_TYPES.MESSAGE]: 67,
  [TASK_TYPES.SMS_SURVEY]: 100,
  [TASK_TYPES.VOICE_RECORDING]: 133,
};

export const AUTOMATED_TASK_TYPE_IDS = AUTOMATED_TASK_TYPES.map((id) => TASK_TYPE_ID_MAP[id]);
export const TEXT_TASK_TYPE_IDS = TEXT_TASK_TYPES.map((id) => TASK_TYPE_ID_MAP[id]);
export const EXCLUDE_BAD_NUMBER_TASK_TYPE_IDS = EXCLUDE_BAD_NUMBER_TASK_TYPES.map(
  (id) => TASK_TYPE_ID_MAP[id]
);
export const SHOW_CONTACTABILITY_FILTER_TASK_TYPE_IDS = SHOW_CONTACTABILITY_FILTER_TASK_TYPES.map(
  (id) => TASK_TYPE_ID_MAP[id]
);

export const TEXTING_TASK_STEP_EXECUTION_TYPES = {
  CREATE: 'create',
  SYNC: 'sync',
  CANCEL: 'cancel',
};

export const TWILIO_MMS_CHARACTER_LIMIT = 1600;

export const MMS_LIMIT_WARNING = `MMS limited to ${TWILIO_MMS_CHARACTER_LIMIT} characters and ${MAX_SMS_MEDIA_LABEL} attachments for sending in most carriers`;
export const TASK_MMS_LIMIT_WARNING = `MMS limited to ${TWILIO_MMS_CHARACTER_LIMIT} characters and ${MAX_TASK_SMS_MEDIA_LABEL} attachments for sending in most carriers`;

export const TASK_VOTER_LIMIT = 5500;

export const MANUAL_VOTER_ACTIVITY_ADDITIONAL_TYPES = {
  OFFICE_VISIT: 'office_visit',
  EMAIL_OUTBOUND: 'email_outbound',
  EMAIL_INBOUND: 'email_inbound',
  DIRECT_MAIL_OUTBOUND: 'direct_mail_outbound',
  DIRECT_MAIL_INBOUND: 'direct_mail_inbound',
  PHONE_CALL_OUTBOUND: 'phone_call_outbound',
  PHONE_CALL_INBOUND: 'phone_call_inbound',
};

export const MANUAL_VOTER_ACTIVITY_TYPES = {
  PHONE: 'phone',
  VISIT: 'visit',
  MESSAGE: 'message',
  // Legacy values kept for backward compatibility
  EMAIL: 'email',
  DIRECT_MAIL: 'direct_mail',
  EXTERNAL_CALL: 'external_call',
  ...MANUAL_VOTER_ACTIVITY_ADDITIONAL_TYPES,
};

export const MANUAL_VOTER_ACTIVITY_ACTIONS = {
  phone: 'Phone Banking',
  visit: 'Door Knocking',
  message: 'Message',
  // Legacy labels
  email: 'Email',
  direct_mail: 'Direct Mail',
  external_call: 'External Call',
  // Current labels
  office_visit: 'Office Visit',
  email_outbound: 'Email - Outbound',
  email_inbound: 'Email - Inbound',
  direct_mail_outbound: 'Direct Mail - Outbound',
  direct_mail_inbound: 'Direct Mail - Inbound',
  phone_call_outbound: 'Phone Call - Outbound',
  phone_call_inbound: 'Phone Call - Inbound',
};
